import Chart from "react-apexcharts";
import "./Heatmap.scss";
import { dayOfWeekMapping, generateTimeLabels } from "../../utils/helper";

const MyHeatmap = ({ subredditData, title }) => {
  // prepare data in the required format

  // Start with x axis (TIME OF DAY)
  let timeOfDay = generateTimeLabels();

  // Continue with data on the y-axis (COUNT OF TOP POSTS)
  let series = [];
  let row = { name: "", data: [] };
  const weekDays = [1, 2, 3, 4, 5, 6, 0];
  weekDays.forEach((key) => {
    // assign name to day of week
    row.name = dayOfWeekMapping[key];

    // store this day's data in an array
    for (const timeKey in subredditData[key]) {
      row.data.push(subredditData[key][timeKey]);
    }
    // add the dayOfWeek's data to the series array
    series.push(row);

    // reset the row obj
    row = { name: "", data: [] };
  });

  const isMobile = window.innerWidth < 768;

  const options = {
    colors: ["#1491ff"],
    title: {
      text: isMobile ? title.split("on")[0].trim() : title,
      style: { fontSize: isMobile ? "16px" : "18px", fontFamily: "revert" },
    },
    chart: { id: "heatmap" },
    yaxis: {
      labels: {
        style: { fontSize: "14px", fontFamily: "system-ui" },
      },
      ...(isMobile
        ? {}
        : {
            title: {
              text: "Day of Week",
              style: { fontSize: "14px", fontFamily: "revert" },
            },
          }),
    },
    xaxis: {
      categories: timeOfDay,
      labels: {
        style: { fontSize: "13px", fontFamily: "system-ui" },
        ...(isMobile
          ? {
              rotate: -60,
              rotateAlways: true,
              formatter: (value) => {
                const index = timeOfDay.indexOf(value);
                return index !== -1 && index % 2 === 0 ? value : "";
              },
            }
          : {}),
      },
      ...(isMobile
        ? {}
        : {
            title: {
              text: "Time of Day",
              style: { fontSize: "14px", fontFamily: "revert" },
            },
          }),
    },
  };

  return (
    <article className="dashboard__heatmap dashboard__heatmap-bottom">
      <Chart
        options={options}
        series={series}
        type="heatmap"
        width="100%"
        height="300"
        id="heatmap"
      />
    </article>
  );
};

export default MyHeatmap;
